"use client";

import { useSiteContext } from "@/components/providers/SiteContextProvider";
import { getTranslations } from "@/lib/i18n";
import { formatGetal, kerstHotelRijen } from "@/lib/kerst-feiten";

// Kerstmarktdeals: blok "Jouw hotels" uit `kerst_hotels` van de bestaande
// deal-detailrespons. Rendert alleen als er data is; geen externe links, geen
// eigen fetch. Geen annuleringsregel per hotel: op een dealpagina gelden onze
// eigen algemene annuleringsvoorwaarden (tabel "Aanvullende informatie").
// De stadsfeiten staan als rijen in die tabel (stadsfeitenRijen, kerst-feiten.js).

/** "Jouw hotels": hotels van de deal (al opgehaald door DealPartnerHotels) met looptijd en score. */
export function KerstJouwHotels({ hotels, kerstHotels }) {
  const { locale } = useSiteContext();
  const { t } = getTranslations(locale);
  const rijen = kerstHotelRijen(hotels, kerstHotels);
  if (!rijen.length) return null;

  return (
    <section className="mt-4" data-testid="kerst-jouw-hotels">
      <h2 className="text-lg font-semibold text-gray-900 mb-2">{t("kerst.hotels.heading")}</h2>
      <ul className="space-y-3">
        {rijen.map(({ hotel, looptijd, score }) => {
          const sterren = Number(hotel.star_rating);
          return (
            <li key={hotel.hotel_id} className="rounded-lg border border-gray-200 bg-white p-3">
              <p className="font-medium text-gray-900">
                {hotel.hotel_name}
                {sterren > 0 && (
                  <span className="ml-2 text-amber-500" aria-label={`${sterren} ★`}>
                    {"★".repeat(Math.min(Math.round(sterren), 5))}
                  </span>
                )}
              </p>
              {looptijd && (
                <p className="text-sm text-gray-700">
                  {t("kerst.hotels.walk", { minuten: formatGetal(looptijd.minuten, locale), markt: looptijd.markt })}
                </p>
              )}
              {score && (
                <p className="text-sm text-gray-700">
                  {t("kerst.hotels.score", {
                    waarde: formatGetal(score.waarde, locale, 1),
                    bron: score.bron,
                    aantal: formatGetal(score.aantalReviews, locale),
                  })}
                </p>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
